import React, { Component } from 'react'
import { connect } from 'react-redux'
import { I18nProvider } from '@lingui/react'

class TranslationProvider extends Component {
  shouldComponentUpdate({ language, translationCatalogs }) {
    if (language === this.props.language || translationCatalogs[language])
      return true
    this.loadCatalog(language)
    return false
  }

  componentDidMount() {
    const { language } = this.props
    this.loadCatalog(language)
  }

  loadCatalog = async language => {
    const { addCatalog } = this.props
    const catalog = await import(/* webpackMode: "lazy", webpackChunkName: "i18n-[index]" */
        `@lingui/loader!../../locale/${language}/messages.json`)
    addCatalog({ language, catalog })
  }

  render() {
    const { language, translationCatalogs, children } = this.props
    if (!translationCatalogs) return null

    return (
      <I18nProvider language={language} catalogs={translationCatalogs}>
        {children}
      </I18nProvider>
    )
  }
}

const mapStateToProps = ({ language, translationCatalogs }) => ({
  language,
  translationCatalogs,
})

const mapDispatchToProps = ({ translationCatalogs: { add } }) => ({
  addCatalog: payload => add(payload),
})

export default connect(mapStateToProps, mapDispatchToProps)(TranslationProvider)



// WEBPACK FOOTER //
// ./src/components/TranslationProvider.js